<!--
 * @Description:常规工作/日常事务 我的工资 详情
 * @Author: 王赵坤
 * @Date: 2023-02-08 11:43:29
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-02-08 11:56:26
 * @FilePath: \VUE3\src\components\home\wodegongzi\detail.vue
-->
<template>
  <div>
    <el-dialog class="w1000 h700" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div>
        <div class="top-biaoti">
          <div class="top-biaoti-wenben">
            <span>
              {{nianfen}}
            </span>
          </div>
        </div>
        <el-descriptions :title="detaildata.xm" :column="4" border>
          <el-descriptions-item label="实发工资" label-align="right" align="center">{{detaildata.sfje}}</el-descriptions-item>
          <el-descriptions-item v-for="(item,index) in detaildata.jzggzxs" :key="index" :label="item.gzxmc" label-align="right" align="center">{{item.je}}</el-descriptions-item>
        </el-descriptions>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openDetail', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow, loadSelect, actionPost } from '@/api/common.js'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const nianfen = ref()
const emits = defineEmits(['update:openDetail'])
const detaildata = ref([])
const getdetaildata = () => {
  actionPost({
    url: '/api/v2/caiwu/jiaozhigonggongzibiao/gongzilist/' + props.row.id
  }).then((res) => {
    detaildata.value = res.data
    nianfen.value = res.data.gzny
  })
}
watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      
      getdetaildata()
    }
  },
  { deep: true, immediate: true }
)
</script>
<style scoped lang="less">
.mx-1 {
  margin-bottom: 20px;
}
.top-biaoti {
  width: 100%;
  .top-biaoti-wenben {
    font-size: 26px;
    font-family: cursive;
    font-weight: 700;
    color: #303133;
  }
}
</style>
